<template>
    <div class="modal">
        <div class="overlay"></div>
        <div class="modal-content well clearfix relative">
            <preloader :display="loading" />

            <div class="modal-header">
                <slot name="modal-header"></slot>
                <a @click.prevent="close()" class="close gray-100">&times;</a>
            </div>

            <div class="modal-body mt-3 prelative">
                <slot name="modal-body"></slot>
            </div>

            <div v-if="hasFooter" class="modal-footer">
                <slot name="modal-footer"></slot>
            </div>
        </div>  
    </div>
</template>

<script>

    import Preloader from "vcomponents/utilities/Preloader.vue";

    export default {
        props: {
            loading : {
                type        : Boolean,
                required    : false,
                default     : false
            }
        },

        computed : {
            hasFooter () {
                return true;
                return !!this.$slots['modal-footer'];
            }
        },
        methods : {
            close () {
                this.$emit('close');
            }
        },

        components: {
            Preloader,
        }
    }
</script>


<style lang="scss" scoped>

    @import '~@sellsy/styleguide/src/_variables';

    .modal {
        .overlay {
            z-index             :999;
            position            :fixed;
            top                 :0;
            left                :0;
            width               :100%;
            height              :100%;
            background-color    :rgba(0,0,0,0.7)
        }

        .modal-content {
            display         : flex;
            flex-direction  : column;
            position        : fixed;
            top             : 50px;
            left            : calc(50% - 404px);
            z-index         : 1000;
            width           : 800px;
            min-height      : 400px;
            max-height      : 600px;

            .modal-header {
                position        : relative;
                border-bottom   : 1px solid $lightgrey;

                .close {
                    cursor      : pointer;
                    position    : absolute;
                    right       : 0px;
                    top         : Opx;
                    font-size   : $val-6;
                    color       : $lightgrey;
                }
            }

            .modal-body {
                flex            : 1 0 auto;
                align-items     : stretch;
                align-content   : stretch;
                max-height      : calc(600px - 160px);
            }

            .modal-footer {
                display         : flex;
                align-items     : center;
                justify-content : flex-end;
            }
        }

        &.confirm {
            .modal-header {
                border-bottom: none;
                text-align: center;

                .close {
                    display: none;
                }
            }
            .modal-content {
                min-height : auto;
                width:420px;
                left : calc(50% - 210px);
                padding  : 32px; 
                font-size: 14px;
                text-align: center;

            }
            .modal-footer {
                margin-top: 24px;
            }
        }
    }
</style>
